import { types } from "../types/types";

const initialState = {
  locationCountries: [],
  locationProvinces: [],
  locationCantons: [],
  locationParishs: [],
  locationCountrySelected: {},
  locationProvinceSelected: {},
  locationCantonSelected: {},
  locationParishSelected: {},

  catalog: {},
  catalogs: [],
  catalogsP: [],
  catalogsS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",
};
export const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOCATION_START_LOADING_COUNTRIES:
      return {
        ...state,
        locationCountries: action.payload,
      };

    case types.LOCATION_SELECT_COUNTRY:
      return {
        ...state,
        locationCountrySelected: action.payload,
      };

      case types.LOCATION_START_LOADING_PROVINCES:
      return {
        ...state,
        locationProvinces: action.payload,
      };

    case types.LOCATION_SELECT_PROVINCE:
      return {
        ...state,
        locationProvinceSelected: action.payload,
      };
    
      case types.LOCATION_START_LOADING_CANTONS:
      return {
        ...state,
        locationCantons: action.payload,
      };

    case types.LOCATION_SELECT_CANTON:
      return {
        ...state,
        locationCantonSelected: action.payload,
      };

      case types.LOCATION_START_LOADING_PARISHS:
        return {
          ...state,
          locationParishs: action.payload,
        };
  
      case types.LOCATION_SELECT_PARISH:
        return {
          ...state,
          locationParishSelected: action.payload,
        };

    case types.LOCATION_CLEAN_COUNTRY:
      return {
        ...state,
        locationProvinceSelected: {},
        locationProvinces: [],
        locationCantonSelected: {},
        locationCantons: [],
        locationParishSelected: {},
        locationParishs: [],
        
      };

    case types.LOCATION_CLEAN_PROVINCE:
      return {
        ...state,
        locationCantonSelected: {},
        locationCantons: [],
        locationParishSelected: {},
        locationParishs: [],
      };

    case types.LOCATION_CLEAN_CANTON:
      return {
        ...state,
        locationParishSelected: {},
        locationParishs: [],
      };

    /* Esto no esta todavia */
    case types.LOCATION_UPDATE:
      if (state.catalogsS.length > 0) {
        return {
          ...state,
          catalogsS: state.catalogsS.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
          catalogsP: state.catalogsP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      } else {
        return {
          ...state,
          catalogsP: state.catalogsP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      }

    case types.LOCATION_DELETE:
      if (state.catalogsS.length > 0) {
        return {
          ...state,
          catalogsS: state.catalogsS.filter((usr) => usr.id !== action.payload),
          catalogsP: state.catalogsP.filter((usr) => usr.id !== action.payload),
          catalog: {},
        };
      } else {
        return {
          ...state,
          catalogsP: state.catalogsP.filter((usr) => usr.id !== action.payload),
          catalog: {},
        };
      }

    case types.LOCATION_START_LOADING_PAGINATED:
      return {
        ...state,
        catalogsP: action.payload.catalogsP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.CATALOG_START_SEARCH:
      return {
        ...state,
        catalogsS: action.payload,
      };

    case types.LOCATION_START_SEARCH_PAGINATED:
      return {
        ...state,
        catalogsS: action.payload.catalogsP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.CATALOG_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        catalogsS: [],
      };

    case types.LOCATION_CLEAN:
      return {
        ...state,
        catalog: {},
      };

    case types.LOCATION_START_REGISTER:
      return {
        ...state,
        catalog: action.payload,
      };

    case types.LOCATION_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    default:
      return state;
  }
};
